import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import { observer } from 'mobx-react';

import { DefaultButton, IconButton } from 'office-ui-fabric-react/lib/Button';

import { localizable } from 'components/Localization';

import './AuctionFinalsMatrix.css';

// props.store = AuctionFinalsStore

@localizable
@observer
export default class AuctionFinalsMatrix extends Component {
  formatObjectCellClassName = (object) =>
    `object ${object.selected ? 'selected' : ''} ${
      object.awarded ? 'awarded' : ''
    }`;

  formatObjectCellContent = (object) => (
    <Fragment>
      {object.name}
      <br />
      {object.title}
    </Fragment>
  );

  formatBuyerRowClassName = (buyer) => `${buyer.awarded ? 'awarded' : ''}`;

  formatBuyerCellClassName = (buyer) =>
    `buyer ${buyer.selected ? 'selected' : ''} ${
      buyer.awarded ? 'awarded' : ''
    }`;

  buyerCellContentFormatter = (buyer) => {
    return buyer.name;

    // const index = buyer.name.indexOf(' ');
    // if (index > 0)
    //   return buyer.name.substr(0, 1) + buyer.name.substr(index + 1, 1);
    // else return buyer.name.substr(0, 3);
  };

  getOfferWarnings = (object, buyer, offer) => {
    const { store, t } = this.props;

    let result = [];

    // any offer for the current property is selected
    const isObjectOfferSelected = object.selected;
    // any offer made by the current buyer is selected
    const isBuyerOfferSelected = buyer.selected;
    // is the current offer selected
    const isCurrentOfferSelected = store.selection[object.id] === buyer.id;
    if (isCurrentOfferSelected) return result;

    // get the highest offer for the current property
    const isHighest = object.highestBuyerId === buyer.id;
    if (isHighest && isObjectOfferSelected)
      result.push(
        t("This is the highest offer for this property, but it's not selected")
      );

    const bestPreference = buyer.preferredOffer;
    const isMostPreferred =
      bestPreference && bestPreference.preference === offer.preference;
    if (isMostPreferred && isBuyerOfferSelected)
      result.push(
        t(
          "This is the most preferred offer for this buyer, but it's not selected"
        )
      );

    return result;
  };

  formatOfferCellTitle = (object, buyer, offer, warnings) => {
    const { currency, locale, t } = this.props;
    let result = `${t('Property')}: ${object.name}
${t('Customer')}: ${buyer.name}
${t('Offer')}: ${offer.price.toFormattedMoney(locale, currency)}
${t('Position')}: ${offer.position + 1} / ${offer.count}
${t('Preference')}: ${offer.preference}`;
    if (offer.awarded) result = result + `\n${t('Awarded')}!`;
    if (warnings.length > 0)
      warnings.forEach((warning) => (result = result + '\n' + warning));
    return result;
  };

  formatOfferCellClassName = (object, buyer, offer, warnings) => {
    const { store } = this.props;
    const isSelected = store.selection[object.id] === buyer.id || offer.awarded;
    const hasWarning = warnings.length > 0;
    return `offer ${isSelected ? 'selected' : hasWarning ? 'warning' : ''} ${
      object.awarded || buyer.awarded ? 'awarded' : ''
    }`;
  };

  formatNonOfferCellClassName = (object, buyer) => {
    if ((!!object && object.awarded) || (!!buyer && buyer.awarded))
      return 'awarded';
    if ((!!object && object.selected) || (!!buyer && buyer.selected))
      return 'selected';
    return '';
  };

  formatOfferCellColor = (object, buyer, offer, warnings) => {
    if (object.awarded || buyer.awarded) return null;
    const { store } = this.props;
    const isSelected = store.selection[object.id] === buyer.id;
    const hue = 120 - Math.round((offer.position / offer.count) * 120);
    return `hsl(${hue}, 100%, ${isSelected ? '40' : '80'}%)`;
  };

  formatOfferCellContent = (object, buyer, offer, warnings) => {
    const hasWarning = warnings.length > 0;
    return (
      <IconButton
        iconProps={{
          iconName:
            !offer.awarded && hasWarning ? 'StatusCircleExclamation' : 'Accept',
        }}
        onClick={this.handleSelect(object.id, buyer.id)}
      />
    );
  };

  handleSelect = (objectId, buyerId) => () => {
    const { store } = this.props;
    store.select(objectId, buyerId);
  };

  handleClearSelection = () => {
    const { store } = this.props;
    store.clearSelection();
  };

  // for each property select most preferred offer if it is also the highest offer
  handleSelectPreferedHighestOffers = () => {
    const { store } = this.props;
    store.objects.forEach((object) => {
      if (
        !object.awarded &&
        object.highestBuyerId &&
        object.offers[0].preference === 1 &&
        !store.isBuyerSelected(object.highestBuyerId)
      )
        store.select(object.id, object.highestBuyerId);
    });
  };

  // for each property select the highest offer (if available, i.e. the highest bidder has not been awarded to another property)
  handleSelectHighestOffers = () => {
    const { store } = this.props;

    store.buyers.forEach((buyer) => {
      if (!buyer.awarded && !store.isBuyerSelected(buyer.id)) {
        // filter only highest offers of the current buyer
        const highestOffers = _.filter(buyer.offers, (offer) => {
          if (offer.awarded || store.isObjectSelected(offer.id)) return false;
          const object = _.find(store.objects, { id: offer.id });
          if (object && object.highestBuyerId === buyer.id) return true;
          return false;
        });
        const bestOffer = _.minBy(highestOffers, 'preference');
        if (bestOffer) store.select(bestOffer.id, buyer.id);
      }
    });
  };

  // for each property select the best (still available) offer
  handleSelectBestOffers = () => {
    const { store } = this.props;
    store.objects.forEach((object) => {
      if (!object.awarded) {
        const availableOffers = _.filter(
          object.offers,
          (offer) => !offer.awarded && !store.isBuyerSelected(offer.buyerId)
        );
        const bestOffer = _.maxBy(availableOffers, (offer) => offer.price);
        if (bestOffer) store.select(object.id, bestOffer.buyerId);
      }
    });
  };

  render() {
    const { store, t } = this.props;

    return (
      <Fragment>
        <div>
          <Fragment>
            <table
              style={{ borderCollapse: 'collapse' }}
              className="auction-finals-matrix"
            >
              <thead>
                <tr>
                  <th></th>
                  {store.objects.map((object) => (
                    <th
                      key={object.id}
                      title={`${object.name} - ${object.title}`}
                      className={this.formatObjectCellClassName(object)}
                    >
                      {this.formatObjectCellContent(object)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {store.buyers.map((buyer) => (
                  <tr
                    key={buyer.id}
                    className={this.formatBuyerRowClassName(buyer)}
                  >
                    <th
                      key="buyer"
                      title={buyer.name}
                      className={this.formatBuyerCellClassName(buyer)}
                    >
                      {this.buyerCellContentFormatter(buyer)}
                    </th>
                    {store.objects.map((object) => {
                      const offer = _.find(
                        buyer.offers,
                        (offer) => offer.id === object.id
                      );
                      const warnings = offer
                        ? this.getOfferWarnings(object, buyer, offer)
                        : [];
                      return (
                        <Fragment key={object.id}>
                          {offer && (
                            <td
                              title={this.formatOfferCellTitle(
                                object,
                                buyer,
                                offer,
                                warnings
                              )}
                              className={this.formatOfferCellClassName(
                                object,
                                buyer,
                                offer,
                                warnings
                              )}
                              style={{
                                backgroundColor: this.formatOfferCellColor(
                                  object,
                                  buyer,
                                  offer,
                                  warnings
                                ),
                                color: 'Red',
                              }}
                            >
                              {this.formatOfferCellContent(
                                object,
                                buyer,
                                offer,
                                warnings
                              )}
                            </td>
                          )}
                          {!offer && (
                            <td
                              className={this.formatNonOfferCellClassName(
                                object,
                                buyer
                              )}
                            ></td>
                          )}
                        </Fragment>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ display: 'none' }}>{store.selectedCount}</div>
          </Fragment>
        </div>
        <div style={{ marginTop: '10px' }}>
          <DefaultButton
            text={t('Clear selection')}
            onClick={this.handleClearSelection}
            style={{ marginRight: '5px' }}
          />
          <DefaultButton
            text={`1. ${t('Select preferred highest offers')}`}
            title={t(
              'For each property pick the highest offer if it is the most preferred offer of the highest bidder'
            )}
            onClick={this.handleSelectPreferedHighestOffers}
            style={{ marginRight: '5px' }}
          />
          <DefaultButton
            text={`2. ${t('Select highest offers')}`}
            title={t(
              'For each property pick the highest offer if the highest bidder has not been assigned to another property yet'
            )}
            onClick={this.handleSelectHighestOffers}
            style={{ marginRight: '5px' }}
          />
          <DefaultButton
            text={`3. ${t('Select best offers')}`}
            title={t('For each property pick the best available offer')}
            onClick={this.handleSelectBestOffers}
          />
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/AuctionFinals/components/AuctionFinalsMatrix.jsx